import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const doHeader = {
  trigger: null,
  doTheHeader: () => {
    const header = document.getElementById('header');
    const footer = document.getElementById('footer');

    if (!header) return;

    if (doHeader.trigger) {
      doHeader.trigger.kill();
      doHeader.trigger = null;
    }

    doHeader.trigger = ScrollTrigger.create({
      id: 'header',
      trigger: 'body',
      start: 'top top',
      end: 'bottom bottom',
      onUpdate: (self) => {
        const isFooterVisible = footer
          ? footer.getBoundingClientRect().top <= 0
          : false;

        if (isFooterVisible) {
          // Treat footer reach as a "top-like" state so nav is shown again.
          header.className = 'header header--top header--bottom';
          return;
        }

        let newClassName = 'header';

        if (self.progress <= 0) {
          newClassName += ' header--top';
        } else {
          newClassName += ' header--notTop';

          if (self.direction === 1) {
            newClassName += ' header--unpinned';
          }
        }

        header.className = newClassName;
      },
    });
  },
  destroyHeader: () => {
    if (doHeader.trigger) {
      doHeader.trigger.kill();
      doHeader.trigger = null;
    }
    const header = document.getElementById('header');
    if (header) {
      header.className = 'header';
    }
  },
};

export default doHeader;
